import { useState } from 'react';
import Typewriter from 'typewriter-effect';

import './App.css';
import logo from './logo.svg';

const status_none = "";
const status_sent = "You've been signed up!"
const status_error = "An error occurred - please try again."
const status_sending = "Sending...";

const onSubmit = async (event, setSubmitText) => {
  event.preventDefault();
  setSubmitText(status_sending);

  const formElements = [...event.currentTarget.elements];
  formElements.pop(); // Remove submit button

  const validFormElements = [];
  for (var i = 0; i < formElements.length; i++) {
    if (formElements.at(i).type === 'radio') {
      if (formElements.at(i).checked) {
        validFormElements.push(formElements.at(i));
      }
    } else {
      validFormElements.push(formElements.at(i));
    }
  }

  if (validFormElements.length < 1) {
    setSubmitText("It looks like you filled out too many fields!");
  } else {
    const filledOutElements = validFormElements
      .filter((elem) => !!elem.value)
      .map((element) =>
        encodeURIComponent(element.name) + "=" + encodeURIComponent(element.value)
      )
      .join("&");

    await fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: filledOutElements.toString(),
    })
      .then(() => {
        setSubmitText(status_sent);
      })
      .catch((_) => {
        setSubmitText(status_error);
      });
  }
};

function App() {
  const [submitText, setSubmitText] = useState(status_none);

  return (
    <div className="container">
      <header className="header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
      <div className="content">
        <h2>The first global case competition community</h2>
        <Typewriter
          onInit={(typewriter) => {
            typewriter.typeString('right here.')
              .pauseFor(2500)
              .start();
          }}
        />

        <p className="prompt">Join our waitlist to be the first to get notified when our product launches.</p>
        <form className="contact-form" name="contact-form" method="POST" data-netlify="true" onSubmit={e => onSubmit(e, setSubmitText)}>
          <input type="hidden" name="form-name" value="contact-form" />
          <p className="row radio-buttons">
            <label>
              <input type="radio" name="role" value="I'm a host" label="host" id="host" required />
              I'm a host
            </label>
            <label>
              <input type="radio" name="role" value="I'm a competitor" label="competitor" id="competitor" />
              I'm a competitor
            </label>
            <label>
              <input type="radio" name="role" value="I'm both" label="both" id="both" />
              I'm both
            </label>
          </p>
          <p className="row">
            <input type="email" name="email" label="email" id="email" placeholder="Your email" required />
            <button type="submit" value="send" id="submit">Sign me up!</button>
          </p>
        </form>
        <p className="submit-msg">{submitText}</p>
      </div >
    </div >
  );
}

export default App;
